import * as React from "react"

type Filter = {
  label: string
  value: string
  onChange: (newValue: string) => void
}

type FilterHeaderProps = {
  title: string
  count?: number
  filters?: Filter[]
}

const FilterHeader = ({ title, count, filters }: FilterHeaderProps) => {
  return (
    <div className="tw:grid tw:grid-cols-2 tw:rounded-md tw:border tw:border-gray-200 tw:bg-gray-50 tw:px-4 tw:py-2">
      <div className="tw:flex tw:items-center tw:gap-2">
        <span className="tw:text-xl tw:font-medium tw:text-gray-800">
          {title}:
        </span>
        {count !== undefined && (
          <span className="tw:rounded-full tw:bg-gray-500 tw:px-3 tw:text-xs tw:text-white">
            {count}
          </span>
        )}
      </div>
      {filters && filters.length > 0 && (
        <div className="tw:flex tw:items-center tw:gap-2">
          <div className="tw:flex tw:items-center tw:gap-2">
            <p className="tw:mb-0! tw:font-medium tw:text-gray-800">Filters:</p>
            {filters.map((filter, index) => (
              <div key={index} className="tw:flex tw:items-center">
                <input
                  type="text"
                  placeholder={filter.label}
                  value={filter.value}
                  onChange={(e) => filter.onChange(e.target.value)}
                  className="tw:w-32 tw:rounded-md tw:border tw:border-gray-300 tw:px-2 tw:py-1 tw:text-sm"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default FilterHeader
